import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
// import Header from './components/Header/Header';
// import SideBar from './components/SideBar/SideBar';
import Dashboard from './components/Dashboard/Dashboard';
import Layout from './components/Layout/Layout';

import GoogleAdManager from './components/Publisher/GAM/GAM';
import ActivePublishers from './components/Publisher/Active-Publisher/Active-Publisher';
import DeactivePublishers from './components/Publisher/DeActivate-Publisher/DeactivatePublisher.js';
import UpdatePublisher from './components/Publisher/Edit-Publisher/Update-Publisher';
import InstreamAdSetting from './components/Publisher/Instream-Ad-Settings/InstreamSetting';
import AddPublisher from './components/Publisher/Add-Publisher/AddPublisher';
import CreateInstreamAd from './components/Publisher/Instream-Ad/CreateInstreamAd';
import AddRoleSet from './components/User-Role/addRoleSet';

import InvoiceList from './components/Invoice/InvoiceList';
import CreateInvoice from './components/Invoice/CreateInvoice';
import UpdateInvoice from './components/Invoice/UpdateInvoice';
import InvoiceSetting from './components/Invoice/InvoiceSetting';

import PubInstreamList from './components/Publisher/Pub-Instream-Setting-List/PubInstreamSettingList';
import CreateInstreaMSetting from './components/Publisher/Instream-Ad-Settings/CreateInstream';
import UpdateInstreamSetting from './components/Publisher/Instream-Ad-Settings/UpdateInstreamSetting';
import AddContentManagement from './components/Content_Management/addContentManagement';
import ListingContentMgmt from './components/Content_Management/listingContentManagement';
import PubInvoiceList from './components/Publisher/PublisherInvoice';
import InstreamAdList from './components/Publisher/Instream-Ad/InstreamAdList';
import UpdateInstreamAd from './components/Publisher/Instream-Ad/UpdateInstreamAd';
import PubDefinition from './components/Publisher/publisher_definition/pubDefinition';
import RecentInvoice from './components/Invoice/RecentInvoice';
import ActiveUserlist from './components/User/ActiveUserList';
import UpdateUser from './components/User/UpdateUser';
import GamSetting from './components/Publisher/GAM/GamSetting';
import DemandPartner1 from './components/Publisher/reporting/demandPartner1';
import RoleListing from './components/User-Role/roleSetListing';
import UserListing from './components/User/userListing';
import AddUser from './components/User/addUser';
import ProtectedRoute from './components/security/protectedRoute.js';
import { AUTH_CODE } from './components/security/authCodes.js';
import Forbidden from './components/security/forbidden.js'
import DemandPartnerSettingList from './components/Demand_Partner_1_Setting/demandPartnerSettingList';
import EditDemandPartnerSetting from './components/Demand_Partner_1_Setting/editGamSetting';
import ViewMapping from './components/Demand_Partner_1_Setting/viewMapping';
import InclusionExclusionList from './components/Demand_Partner_1_Setting/inclusionExclusionList';
import ScheduleInstreamSetting from './components/Publisher/Instream-Ad-Settings/scheduleInstreamSetting';

// import AddContentManagement from './components/Content_Management/addContentManagement';

import TrPanelLogs from './components/Tr_Panel_Logs/trPanelLogs.js';
import AdPlacement from './components/Publisher/Ad-Placement/AdPlacement';
import AdPlacementList from './components/Publisher/Ad-Placement/AdPlacementList';
import PublisherInfo from './components/Publisher/Publisher-Info/PublisherInfo.js';
import ViewDashboard from './components/Login/viewDashboard.js';
import Amp from './components/Publisher/Ad-Placement/Amp.js';
import TranscodingInfo from './components/Content_Management/transcodeInfo.js';

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            {/* <Route path ="/header" element={<Header />} /> */}
            {/* <Route path ="/sidebar" element={<SideBar />} /> */}
            <Route path="/dashboard" element={
                // no need to protect that side bar it will protect by inter code 
                // <ProtectedRoute code={AUTH_CODE.gamReporting.gamReport}>
                <Layout><Dashboard /></Layout>
                // </ProtectedRoute>
            } />

            <Route path="/active-publisher" element={
                <ProtectedRoute code={AUTH_CODE.accounts.publisherListing}>
                    <Layout><ActivePublishers /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/inactive-publisher" element={
                <ProtectedRoute code={AUTH_CODE.accounts.publisherListing}>
                    <Layout><DeactivePublishers /></Layout>
                </ProtectedRoute>
            } />
            {/* <Route path = "/add-publisher-1" element={<Layout><AddPublisher /></Layout>} /> */}
            <Route path="/add-publisher" element={
                <ProtectedRoute code={AUTH_CODE.accounts.createPublisher}>
                    <Layout><AddPublisher /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/publisher/edit/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.accounts.editUpdatePublisher}>
                    <Layout><UpdatePublisher /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/GAM" element={<Layout><GoogleAdManager /></Layout>} />

            <Route path="/publisher/add-instream-ad/:id/:guid" element={<Layout><CreateInstreamAd /></Layout>} />
            <Route path="/publisher/edit/instream-ad/:adId/:id/:guid" element={<Layout><UpdateInstreamAd /></Layout>} />

            <Route path="/role/add" element={
                <ProtectedRoute code={AUTH_CODE.userRole.userRoleSetting}>
                    <Layout><AddRoleSet /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/role/:id" element={
                <ProtectedRoute code={AUTH_CODE.userRole.userRoleSetting}>
                    <Layout><AddRoleSet /></Layout>
                </ProtectedRoute>
            } />

            {/* User */}
            <Route path="/user/:id" element={
                <ProtectedRoute code={AUTH_CODE.user.editUpdate}>
                    <Layout><AddUser /></Layout>
                </ProtectedRoute>} />
            <Route path="/user/add" element={
                <ProtectedRoute code={AUTH_CODE.user.create}>
                    <Layout><AddUser /></Layout>
                </ProtectedRoute>} />
            <Route path="/user" element={
                <ProtectedRoute code={AUTH_CODE.user.listing}>
                    <Layout><UserListing /></Layout>
                </ProtectedRoute>}
            />
            <Route path="/role" element={
                <ProtectedRoute code={AUTH_CODE.userRole.userRoleSetting}>
                    <Layout><RoleListing /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/publisher/instream-setting-list/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.instreamTagSetting.manageInstreamSetting}>
                    <Layout><PubInstreamList /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/publisher/add/instream-setting/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.instreamAdSetup.createInstreamAd}>
                    <Layout><CreateInstreaMSetting /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/publisher/edit/instream-setting/:adId/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.instreamAdSetup.updateInstreamAd}>
                    <Layout><UpdateInstreamSetting /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/publisher/instream-ad-list/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.instreamAdSetup.instreamListing}>
                    <Layout><InstreamAdList /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/publisher/gam-setting/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.gamSetting.createUpdateGamSetting}>
                    <Layout><GamSetting /></Layout>
                </ProtectedRoute>
            } />

            {/* no need to protect */}
            <Route path="/publisher/info/:id/:guid" element={<Layout><PublisherInfo /></Layout>} />

            <Route path="/invoice-list/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.financeInvoice.invoiceListing}>
                    <Layout><InvoiceList /></Layout>
                </ProtectedRoute>}
            />

            <Route path="/publisher/invoice-list/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.publisherInvoice.invoiceListing}>
                    <Layout><PubInvoiceList /></Layout>
                </ProtectedRoute>}
            />

            <Route path="/add-invoice/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.financeInvoice.createInvoice}>
                    <Layout><CreateInvoice /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/update-invoice/:invId/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.financeInvoice.editUpdateInvoice}>
                    <Layout><UpdateInvoice /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/invoice-setting/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.invoiceSetting.createUpdateInvoiceSetting}>
                    <Layout><InvoiceSetting /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/publisher/recent-invoice/" element={
                <ProtectedRoute code={AUTH_CODE.financeInvoice.invoiceRecentActivity}>
                    <Layout><RecentInvoice /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/:guid/instream-setting" element={<Layout><InstreamAdSetting /></Layout>} />

            <Route path="/publisher/adplacement-list/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.adPlacement.adPlacementListing}>
                    <Layout><AdPlacementList /></Layout>
                </ProtectedRoute>
            } />

            <Route path="/publisher/adplacement/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.adPlacement.createAdPlacement}><Layout><AdPlacement /></Layout></ProtectedRoute>
            } />
            <Route path="/publisher/edit/adplacement/:id/:guid/:placementId" element={
                <ProtectedRoute code={AUTH_CODE.adPlacement.editUpdateAdPlacement}><Layout><AdPlacement /></Layout></ProtectedRoute>
            } />
            <Route path="/publisher/adplacement/amp/:id/:guid" element={
                <ProtectedRoute code={AUTH_CODE.adPlacement.generateAmpTags}><Layout><Amp /></Layout></ProtectedRoute>
            } />

            {/* Content Management */}
            <Route path="/content-management/transcoding-info" element={
                <ProtectedRoute code={AUTH_CODE.contentManagement.transcoding}><Layout><TranscodingInfo /></Layout></ProtectedRoute>
            } />
            <Route path="/content-management/add" element={
                <ProtectedRoute code={AUTH_CODE.contentManagement.create}>
                    <Layout><AddContentManagement /></Layout>
                </ProtectedRoute>}
            />
            <Route path="/content-management/:id" element={
                <ProtectedRoute code={AUTH_CODE.contentManagement.editUpdate}>
                    <Layout><AddContentManagement /></Layout>
                </ProtectedRoute>}
            />
            <Route path="/content-management" element={
                <ProtectedRoute code={AUTH_CODE.contentManagement.listing}>
                    <Layout><ListingContentMgmt /></Layout>
                </ProtectedRoute>}
            />



            {/* Definition */}
            <Route path="/publisher-definition" element={
                <ProtectedRoute code={AUTH_CODE.defination.getIdDefination}>
                    <Layout><PubDefinition /></Layout>
                </ProtectedRoute>}
            />

            {/* Reporting */}
            <Route path="/reporting-gam" element={
                <ProtectedRoute code={AUTH_CODE.gamReporting.gamReport}><Layout><DemandPartner1 /></Layout></ProtectedRoute>
            } />

            {/* Demand partner  */}
            <Route path="/gamsetting" element={
                <ProtectedRoute code={AUTH_CODE.demandPartner.gamSettingListing}>
                    <Layout><DemandPartnerSettingList /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/gamsetting/:gamId/edit" element={
                <ProtectedRoute code={AUTH_CODE.demandPartner.editUpdateGamSetting}>
                    <Layout><EditDemandPartnerSetting /></Layout>
                </ProtectedRoute>
            } />
            <Route path="/gamsetting/:gamId/:pubId/:showGamMapping/gam/mapping" element={
                <ProtectedRoute code={AUTH_CODE.demandPartner.gamViewMappingList}>
                    <Layout><ViewMapping /></Layout>
                </ProtectedRoute>
            } />

            {/* No need to protect */}
            <Route path="/gamsetting/list/inclusion_exclusion" element={
                <Layout><InclusionExclusionList /></Layout>
            } />

            {/* schedule instream */}
            <Route path="/publisher/:instreamId/:instreamGuid/:accId/:pubGuid/scheduleInstream" element={
                <ProtectedRoute code={AUTH_CODE.instreamTagSetting.scheduleInstream}>
                    <Layout><ScheduleInstreamSetting /></Layout>
                </ProtectedRoute>
            } />


            {/* Tr Panel Logs */}
            <Route path="/tr-panel-logs" element={
                <ProtectedRoute code={AUTH_CODE.userTracker.trPanelLogs}>
                    <Layout><TrPanelLogs /></Layout>
                </ProtectedRoute>}
            />

            <Route path="/view/dashboard" element={<ViewDashboard />} />

            {/* Error Pages */}
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    )
}


export default AppRoutes;